// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "code[data-v-72ccaef3]{font-size:.75rem}.editor-expresion textarea[data-v-72ccaef3]{font-family:monospace;font-size:13px;line-height:1.4;white-space:pre}.info-tooltip[data-v-72ccaef3]{max-width:360px;white-space:normal}.info-section[data-v-72ccaef3]{margin-bottom:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
